import React from "react";
import { ItemsStore, RolesAndPermissionStore } from "../../shared/store";
import { MerchantAccountStore } from "../merchantAccounts";
import {
  CustomPlaceholders,
  DashboardTopBar,
  ItemContentArea,
} from "../../shared/components";
import MerchantPortalPopUp from "../../shared/components/MerchantPortalPopUp";
import {
  CustomLabel,
  SapphireBlueButton,
} from "@mindmemobile/mm-shared-global";
import { CenterContainer } from "../funding/FundingDisputesStyles";
// import DisputePlhIcon from "../../assets/images/dispute-placeholder.svg";
import DisputePlhIcon from "../../../../../images/placeholders/warning-muted-grey.svg";
import { MainOuterCard } from "../../shared/styles";
import styled from "styled-components";

type IProps = {
  itemStore: ItemsStore;
  merchantAccountStore: MerchantAccountStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

const DisputePlaceholderWrapper = styled.span`
  .dispute-plh {
    background-color: #fff;
  }
  .plh-description {
    padding: 0.5rem;
    max-width: 40ch;
  }
`;
const DisputesPage: React.FC<IProps> = ({
  itemStore,
  merchantAccountStore,
  rolesAndPermissionStore,
}) => {
  const [showMerchantPopUp, setShowMerchantPopUp] = React.useState(false);

  function renderDetails(node: React.ReactNode) {
    return (
      <>
        <DashboardTopBar
          itemStore={itemStore}
          rightContent={<></>}
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
        />
        <ItemContentArea
          itemStore={itemStore}
          node={node}
          onlyShowNotificationBox={false}
          showMerchantAccountNotificationBar={merchantAccountStore.hasNotificationBar()}
        />
      </>
    );
  }

  const renderMerchantPopUp = () => {
    if (!process.env.REACT_APP_MERCHANT_PORTAL) return null;
    return (
      <MerchantPortalPopUp
        onClickLogin={() => {
          window.open(process.env.REACT_APP_MERCHANT_PORTAL, "_blank");
          setShowMerchantPopUp(false);
        }}
        onClose={() => setShowMerchantPopUp(false)}
      />
    );
  };

  const onClickButton = () => {
    setShowMerchantPopUp(true);
  };

  return renderDetails(
    <>
      {showMerchantPopUp && renderMerchantPopUp()}
      {/* <CenterContainer>
        <CustomLabel className="funding-plh-heading">Disputes</CustomLabel>
        <CustomLabel className="funding-plh-text">
          Login to the Merchant Portal to view disputes <br />
          and respond to chargebacks.
        </CustomLabel>
        <SapphireBlueButton
          className="funding-btn"
          onClick={() => onClickButton()}
        >
          Login to Merchant Portal
        </SapphireBlueButton>
      </CenterContainer> */}
      <DisputePlaceholderWrapper>
        <CustomPlaceholders
          image={DisputePlhIcon}
          label={"Disputes"}
          description={
            "Login to the Merchant Portal to view disputes and respond to chargebacks."
          }
          // showItems={config?.showItems}
          customButton={
            <SapphireBlueButton
              className="funding-btn plh-btn"
              onClick={() => onClickButton()}
            >
              Login to Merchant Portal
            </SapphireBlueButton>
          }
          className="dispute-plh"
        />
      </DisputePlaceholderWrapper>
    </>
  );
};

export default DisputesPage;
